import React, { Component } from 'react';
import { APP_CONST } from '../../../../constants';
import { GeckoAlert, Spinner } from '../../../../components';
import { Auth } from '../../../../services';
import SessionTable from '../../../active-sessions/components/SessionTable';

export class ModuleActiveSessions extends Component {
    state = {
        sessions: [],
        alert: null,
        loading: false,
    }

    constructor(props) {
        super(props);
        this.getSessions = this.getSessions.bind(this);
        this.deleteToken = this.deleteToken.bind(this);
    }

    componentDidMount() {
        this.getSessions();
    }

    getSessions() {
        this.setState({ loading: true });
        
        return Auth.sessions().then((data) => {
            this.setState({
                sessions: data,
                loading: false,
            })
        })
        .catch((err) => {
            this.setState({ 
                alert: err.Error,
                loading: false,
            });
        })
    }

    deleteToken(setId) {
        Auth.deleteApiToken(setId)
        .then(() => {
            const sessions = this.state.sessions;
            const updatedSessions = sessions.filter((session) => session.SetId !== setId);
            this.setState({
                sessions: updatedSessions,
            })
        });
    }

    renderAlert(message = null) {
        if (message) {
            return (
                <GeckoAlert type={APP_CONST.ALERT_TYPE_DANGER}>
                    {message}
                </GeckoAlert>
            )
        }
        return null;
    }

    renderSpinner(loading = false) {
        if (!loading) return null;

        return (
            <div className="flex items-center justify-center">
                <Spinner />
            </div>
        )
    }

    renderSessions(sessions) {
        if (this.state.loading) {
            return null;
        }

        if (sessions.length === 0) {
            return (
                <div className="text-sm text-muted-foreground">
                    No active sessions
                </div>
            )
        }

        return (
            <SessionTable data={this.state.sessions} revoke={this.deleteToken} />
        )
    }

    render() {
        return (
            <div className="flex flex-col gap-4">
                {this.renderAlert(this.state.alert)}
                {this.renderSessions(this.state.sessions)}
                {this.renderSpinner(this.state.loading)}
            </div>
        );
    }
}

export default ModuleActiveSessions; 